import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';
import { camelCase } from 'lodash';

export class EstateUpsellClearEstateMeta extends BaseModel {
  /**
   * @var {number}
   */
  parentId;

  /**
   * @var {?boolean}
   */
  needsNotifyCreditors;

  /**
   * @var {?boolean}
   */
  needsRealEstateTitleSearch;

  /**
   * @var {?boolean}
   */
  needsWillSearch;

  constructor(model = {}) {
    super();

    this.parentId = model.parentId;
    this.needsNotifyCreditors = model.needsNotifyCreditors;
    this.needsRealEstateTitleSearch = model.needsRealEstateTitleSearch;
    this.needsWillSearch = model.needsWillSearch;
  }

  setUpsellAsTrue(type) {
    this[camelCase(type)] = true;
  }

  getUpsellValue(type) {
    return this[camelCase(type)];
  }
}
